(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eased-product"] && !Shopify.designMode) return;
  try {
    
const root=document.querySelector('[data-eased-product]');if(root){const form=root.querySelector('.ep-form');const qty=form?.querySelector('[data-quantity-input]');const radios=root.querySelectorAll('input[name="eased_quantity"]');const prices={1:root.querySelector('.ep-supply-grid label:nth-child(1) small')?.textContent,3:root.querySelector('.ep-supply-grid label:nth-child(2) small')?.textContent,6:root.querySelector('.ep-supply-grid label:nth-child(3) small')?.textContent};radios.forEach(r=>r.addEventListener('change',()=>{radios.forEach(x=>x.closest('label')?.classList.toggle('is-selected',x.checked));if(qty)qty.value=r.value;const p=root.querySelector('[data-atc-price]');if(p)p.textContent=prices[r.value]||''}));root.querySelector('[data-sticky-atc]')?.addEventListener('click',()=>root.querySelector('.ep-atc')?.click())}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eased-storefront"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eased-storefront')) {
  customElements.define('eased-storefront', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const slides = this.querySelector('[data-slides]');
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let index = 0;
      const move = i => {
        index = Math.max(0, Math.min(slides.children.length - 1, i));
        slides.scrollTo({left:index * slides.clientWidth, behavior:reduced ? 'instant' : 'smooth'});
      };
      thumbs.forEach((thumb,i) => thumb.addEventListener('click', () => move(i), {signal}));
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => move(index - 1), {signal});
      this.querySelector('[data-gallery-next]').addEventListener('click', () => move(index + 1), {signal});
      slides.addEventListener('keydown', e => {if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); move(index + (e.key === 'ArrowRight' ? 1 : -1));}}, {signal});
      slides.addEventListener('scroll', () => {
        index = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed', String(i === index)));
        this.querySelector('[data-gallery-count]').textContent = `${index + 1} / ${slides.children.length}`;
      }, {signal, passive:true});
      const form = this.querySelector('[data-form]');
      if (this.dataset.preview === 'true') form.querySelector('.es-atc').addEventListener('click', () => {
        const status = this.querySelector('[data-form-status]');
        status.textContent = status.dataset.previewMessage;
      }, {signal});
      const update = () => {
        const chosen = form.querySelector('input[type=radio]:checked');
        form.querySelector('[data-quantity]').value = chosen.value;
        this.querySelector('[data-total-price]').textContent = chosen.dataset.total;
        this.querySelector('[data-sticky-price]').textContent = chosen.dataset.total;
        this.querySelectorAll('[data-compare-price]').forEach(el => {el.textContent = chosen.dataset.compare; el.hidden = chosen.dataset.hasSaving !== 'true';});
        form.querySelectorAll('.es-offer').forEach(offer => {
          const input = offer.querySelector('input[type=radio]');
          const detail = offer.querySelector('.es-offer-detail');
          detail.hidden = !input.checked;
        });
        this.querySelectorAll('[data-gift]').forEach(gift => {
          const locked = Number(chosen.value) < Number(gift.dataset.gift);
          gift.classList.toggle('is-locked', locked);
          gift.querySelector('.es-gift-state').textContent = locked ? '+' : '✓';
          gift.querySelector('[data-gift-status]').textContent = locked ? gift.dataset.unlockLabel : this.dataset.unlocked;
        });
      };
      form.addEventListener('change', update, {signal});
      update();
      this.querySelector('[data-sticky-buy]').addEventListener('click', () => {this.querySelector('.es-buybox').scrollIntoView({behavior:reduced ? 'instant':'smooth', block:'start'}); form.querySelector('.es-atc').click();}, {signal});
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const status = this.querySelector('[data-form-status]');
        if (this.dataset.preview === 'true') {status.textContent = status.dataset.previewMessage; return;}
        const submit = form.querySelector('[type=submit]');
        if (submit.disabled || !form.elements.id.value) return;
        submit.disabled = true;
        submit.setAttribute('aria-busy','true');
        status.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:form.elements.id.value,quantity:Number(form.querySelector('[data-quantity]').value)}]})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || status.dataset.errorMessage);
          window.location.assign(this.dataset.cartUrl);
        } catch(error) {status.textContent = error.message || status.dataset.errorMessage; submit.disabled = false; submit.removeAttribute('aria-busy');}
      }, {signal});
      this.querySelectorAll('.es-menu a').forEach(link => link.addEventListener('click', () => this.querySelector('.es-menu').removeAttribute('open'), {signal}));
    }
    disconnectedCallback() {this.controller?.abort(); this.initialized = false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
